import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';

/**
 * Mobile-only bottom bar that appears once the hero CTA is out of view
 * and hides while an offer card is on screen.
 */
export function StickyMobileCTA() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const targets = ['pricing', 'final-offer'].map(id => document.getElementById(id)).filter((el): el is HTMLElement => Boolean(el));
    const visible = new Set<Element>();
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visible.add(entry.target);else visible.delete(entry.target);
      });
      setOfferVisible(visible.size > 0);
    }, {
      threshold: 0.1
    }) : null;
    targets.forEach(el => observer?.observe(el));
    return () => {
      window.removeEventListener('scroll', onScroll);
      observer?.disconnect();
    };
  }, []);
  const show = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-396" data-mp="29a9aojn5g0cy">
      {show && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-slate-950/90 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-md md:hidden" data-id="element-397" data-mp="29b15hs8x9u26">
          <div className="flex items-center gap-3" data-id="element-398" data-mp="3tp1j2ln1lqvf">
            <div className="min-w-0 flex-1" data-id="element-399" data-mp="3png8j6xzdooe">
              <p className="font-display text-xl font-black italic leading-none text-white" data-id="element-400" data-mp="3pohn3le7gtav">
                $17 USD{' '}
                <span className="text-sm font-bold not-italic text-slate-500 line-through" data-id="element-401" data-mp="1mzhn8y5cgh76">$79</span>
              </p>
              <p className="mt-0.5 text-[11px] text-slate-400" data-id="element-402" data-mp="1e0w7far9bga3">Pago único · Garantía 7 días</p>
            </div>
            <a href="#pricing" className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-blue-600 px-5 py-3 text-sm font-bold uppercase tracking-wide text-white transition-transform duration-150 active:scale-[0.98]" data-id="element-403" data-mp="1i1pxa9o9f55m">
              Lo quiero <ArrowRightIcon size={15} aria-hidden="true" data-id="element-404" data-mp="1wr45vfk0hijy" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}